import React from "react";
import Slider, { Settings } from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  NextArrow,
  CarouselWrapper,
  DogeImg,
  DogeInfo,
  ImgContainer,
  MintedDogeWrapper,
  MintedInfo,
  StyledDots,
  StyledDotsWrapper,
  PrevArrow,
} from "./styled";
import { mintedDoge } from "./mintedDoge";

interface Props {
  show?: number;
  scroll?: number;
}

const MintedList = ({ show, scroll }: Props) => {
  const settings: Settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: !show ? 4 : show,
    slidesToScroll: !scroll ? 4 : show,
    appendDots: (dots) => <StyledDotsWrapper>{dots}</StyledDotsWrapper>,
    customPaging: (i) => <StyledDots className="custom-dots"></StyledDots>,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 629,
        settings: {
          arrows: false,
          dots: false,
          slidesToShow: 2.5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          dots: false,
          slidesToShow: 1.5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 960,
        settings: {
          arrows: true,
          dots: true,
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
    ],
  };
  return (
    <Slider {...settings}>
      {mintedDoge.map((doge, idx) => (
        <MintedDogeWrapper key={idx}>
          <MintedInfo>
            <ImgContainer>
              <DogeImg src={doge.img} alt="" />
            </ImgContainer>
            <DogeInfo>DOGE #{doge.id}</DogeInfo>
          </MintedInfo>
        </MintedDogeWrapper>
      ))}
    </Slider>
  );
};

export default MintedList;
